import { environment } from '../environments/environment';

export function formatDurationFromSecond(duration: number): string {
  let secondDuration = duration;
  let negative = '';

  if (secondDuration < 0) {
    secondDuration = secondDuration * -1;
    negative = '-';
  }

  const hours = Math.floor(secondDuration / 3600);
  const minutes = Math.floor((secondDuration - hours * 3600) / 60);
  const seconds = parseInt((secondDuration - hours * 3600 - minutes * 60).toFixed(0), 10);

  let hoursDt = hours.toString();

  if (hours < 10) {
    hoursDt = `0${hoursDt}`;
  }

  let minutesDt = minutes.toString();

  if (minutes < 10) {
    minutesDt = `0${minutesDt}`;
  }

  let secondsDt = seconds.toString();

  if (seconds < 10) {
    secondsDt = `0${secondsDt}`;
  }

  return `${negative + hoursDt}:${minutesDt}:${secondsDt}`;
}


export function getApiUrl(): string {
  if (environment.production) {
    return 'https://devices.scm3d.com';
  }
  return `https://local-device-management.scm3d.com:6002`;
}

 export function findOneOptionForSelect<T>(collection: T[], value: unknown, key: string | number = 'id'): T[] {
    const item: T | undefined = collection.find((item: T) => key in item && item[key as keyof T] === value);
     return item !== undefined ? [item] : ([] as T[]);
}
